export default __webpack_public_path__ + "static/media/LGPD.c534e0b8.png";